import VxeRadioButtonComponent from '../radio/src/button';
import { dynamicApp } from '../dynamics';
export var VxeRadioButton = Object.assign(VxeRadioButtonComponent, {
    install: function (app) {
        app.component(VxeRadioButtonComponent.name, VxeRadioButtonComponent);
    }
});
export var RadioButton = VxeRadioButton;
dynamicApp.component(VxeRadioButtonComponent.name, VxeRadioButtonComponent);
export default VxeRadioButton;
